import { render, staticRenderFns } from "./seckillData.vue?vue&type=template&id=1272d4f0&scoped=true"
import script from "./seckillData.vue?vue&type=script&lang=js"
export * from "./seckillData.vue?vue&type=script&lang=js"
import style0 from "./seckillData.vue?vue&type=style&index=0&id=1272d4f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1272d4f0",
  null
  
)

export default component.exports